import strings from 'localization/strings';

const conversationCategories = {
    general: {
        allowUploadImages: false
    },
    faultReport: {
        allowUploadImages: true
    }
};

Object.keys(conversationCategories).forEach(key => {
    conversationCategories[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(conversationCategories).forEach(o => {
        o.title = strings.conversationCategories[o.key];
        o.instruction = strings.conversationCategoryInstructions[o.key];
        o.imageDropzoneText = strings.conversationCategoryImageDropzoneTexts[o.key];
    });
});

export default conversationCategories;
